export const defaultSettings = {
  navTheme: "realDark",
  colorPrimary: "#FA541C",
  layout: "top",
  contentWidth: "Fluid",
  fixedHeader: true,
  fixSiderbar: true,
  pwa: true,
  logo: "https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg",
  splitMenus: false,
};
